// javascript has unicode counting problem. some chars may have length of 2 instead 1. this is the solution to fix it:
// https://mathiasbynens.be/notes/javascript-unicode
export const countSymbols = (string: string): number => {
  return Array.from(string).length;
};
